import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/living-thing.vue
var s = {
	name: "DtIconLivingThing",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--living-thing"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Living Thing",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "m2.125 1.802 1.47.616c.582.245 1.2.228 1.735.138a4.03 4.03 0 0 1 1.34 0c.535.09 1.154.106 1.736-.138l1.37-.574-.298 1.19c-.172.693-.01 1.38.223 1.946a4 4 0 1 1-7.478.2c.153-.437.264-.948.185-1.48l-.283-1.898Zm-.99.147A1 1 0 0 1 2.51.879l1.472.617c.334.14.737.149 1.182.074a5.03 5.03 0 0 1 1.673 0c.445.075.847.067 1.182-.074l1.37-.575h.002a1 1 0 0 1 1.355 1.164l-.297 1.191c-.1.399-.018.85.177 1.323a5 5 0 1 1-9.347.251c.126-.362.186-.697.14-1.003L1.136 1.95ZM3.9 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.4a.5.5 0 0 1-.5-.5Zm3.1 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H7.5a.5.5 0 0 1-.5-.5Zm-2 2a.625.625 0 0 1 .5-1h1c.515 0 .81.588.5 1l-.5.667a.625.625 0 0 1-1 0L5 6.5Zm1 2.333.221.133a2 2 0 0 0 2.058 0l.062-.037a.5.5 0 1 0-.515-.858l-.061.037a1 1 0 0 1-1.03 0l-.413-.248a.625.625 0 0 0-.643 0l-.414.248a1 1 0 0 1-1.03 0l-.061-.037a.5.5 0 0 0-.515.858l.062.037a2 2 0 0 0 2.058 0L6 8.833Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=living-thing.js.map